import React from 'react';

interface Props {
  src: string;
}

export const Video: React.FC<Props & React.VideoHTMLAttributes<HTMLVideoElement>> = ({
  children,
  controls = false,
  muted = true,
  playsInline = true,
  src,
  ...attrs
}) => {
  const filename = src?.replace( /\.[^/.]+$/, '' );
  const videoRef = React.useRef( undefined );

  React.useEffect(() => {
    if( muted ){
      videoRef.current.defaultMuted = true;
      videoRef.current.muted = true;
    }
  })

  return (
    <video
      id="video"
      muted={muted}
      controls={controls}
      controlsList="nodownload"
      playsInline={playsInline}
      ref={videoRef}
      {...attrs}
    >
      <source src={`${filename}.webm`} type="video/webm" />
      <source src={`${filename}.mp4`} type="video/mp4" />
      {children}
    </video>
  );
};
